import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import Vuelidate from 'vuelidate'
import VuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";
import FormGroup from '@/components/templates/FormGroup';
import MultiError from '@/components/templates/MultiError';
import VueLogger from 'vuejs-logger';
import errorResponseHandler from "@/services/errorResponseHandler";
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import Axios from '@/plugins/axios-plugin';
import { store } from './store/store'
import vSelect from 'mdh-vue-select'

import VueFormWizard from 'vue-form-wizard'

import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import i18n from './i18n'
import moment from 'moment'

import VueTheMask from 'vue-the-mask'

import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.use(Toast, {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true
})

Vue.use(VueTheMask)

Vue.use(VueFormWizard)


//import VueBrowserUpdate from '@sum.cumo/vue-browserupdate';
//import Es6Promise from 'es6-promise'
//Es6Promise.polyfill()

//Vue.use(VueBrowserUpdate, {
//  options: {
//  required:{
//    e:16,
//    i:12,
//    f:58,
//    o:51,
//    o_a:45,
//    s:-1,
//    c:"67.0.3396.12",
//    y:18.1,
//    v:"1.10",
//    uc:11.5,
//    samsung:7.0
//}}
//});

Vue.config.productionTip = false
Vue.use(Vuelidate)

Vue.component('v-select', vSelect)

Vue.use(VuelidateErrorExtractor, {
  i18n: false,
  template: FormGroup,
  messages: {
    required: "{attribute} is required.",
    email: "{attribute} is not a valid Email Address.",
    numeric: "{attribute} must be a numeric value.",
    checked: "{attribute}",
    minDate: "{attribute} is before the minimum allowed date.",
    maxDate: "{attribute} is after the maximum allowed date.",
    maxLength: "{attribute} exceeds the maximum length.",
    isValid: "{attribute} is not formatted correctly.",
    understandStatement:"{attribute}: You must agree to the statement."
  },
  attributes: {
    'form.putativeFather.name.first': 'Putative Father First Name',
    'form.putativeFather.name.middle': 'Putative Father Middle Name',
    'form.putativeFather.name.last': 'Putative Father Last Name',
    'form.putativeFather.name.suffix': 'Putative Father Suffix',
    'form.putativeFather.alias': 'Putative Father Alias',
    'form.putativeFather.dateOfBirth': 'Putative Father Date of Birth',
    'form.putativeFather.ssn': 'Putative Father Social Security Number',
    'form.putativeFather.mailingAddress.streetAddress1': 'Putative Father Mailing Address Line 1',
    'form.putativeFather.mailingAddress.streetAddress2': 'Putative Father Mailing Address Line 2',
    'form.putativeFather.mailingAddress.city': 'Putative Father Mailing Address City',
    'form.putativeFather.mailingAddress.state': 'Putative Father Mailing Address State',
    'form.putativeFather.mailingAddress.postalCode': 'Putative Father Mailing Address ZIP Code',
    'form.putativeFather.notificationAddress.streetAddress1': 'Putative Father Notification Address Line 1',
    'form.putativeFather.notificationAddress.streetAddress2': 'Putative Father Notification Address Line 2',
    'form.putativeFather.notificationAddress.city': 'Putative Father Notification Address City',
    'form.putativeFather.notificationAddress.state': 'Putative Father Notification Address State',
    'form.putativeFather.notificationAddress.postalCode': 'Putative Father Notification Address ZIP Code',

    'form.mother.name.first': 'Mother First Name',
    'form.mother.name.middle': 'Mother Middle Name',
    'form.mother.name.last': 'Mother Last Name',
    'form.mother.name.suffix': 'Mother Suffix',
    'form.mother.alias': 'Mother Alias',
    'form.mother.dateOfBirth': 'Mother Date of Birth',
    'form.mother.ssn': 'Mother Social Security Number',
    'form.mother.mailingAddress.streetAddress1': 'Mother Mailing Address Line 1',
    'form.mother.mailingAddress.streetAddress2': 'Mother Mailing Address Line 2',
    'form.mother.mailingAddress.city': 'Mother Mailing Address City',
    'form.mother.mailingAddress.state': 'Mother Mailing Address State',
    'form.mother.mailingAddress.postalCode': 'Mother Mailing Address ZIP Code',

    'form.child.name.first': 'Child First Name',
    'form.child.name.middle': 'Child Middle Name',
    'form.child.name.last': 'Child Last Name',
    'form.child.name.suffix': 'Child Suffix',
    'form.child.gender': 'Child Gender',
    'form.child.birthDetails.birthDateKnown': 'Child Birth Date Known',
    'form.child.birthDetails.birthDate': 'Child Birth Date',
    'form.child.birthDetails.birthMonth': 'Child Birth Month',
    'form.child.birthDetails.birthYear': 'Child Birth Year',
    'form.child.birthDetails.hospitalName': 'Child Birth Hospital Name',
    'form.child.birthDetails.cityOfBirth': 'Child Birth City',
    'form.child.birthDetails.stateOfBirth': 'Child Birth State',

    'form.courtOrder.courtOrderIssued': 'Court Order Issued',
    'form.courtOrder.courtFileNbr': 'Court File Number',

    'form.signature.statement': 'Signature',
    'form.signature.signedName': 'Signature Name',
    'form.signature.signedDate': 'Signature Date',

  }
});

Vue.component('form-summary', MultiError)

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
});

Vue.filter('formatTime', function(value) {
  if (value) {
    return moment(String(value)).format('h:mm a')
  }
});

const options = {
  isEnabled: true,
  logLevel : Vue.config.productionTip  ? 'error' : 'debug',
  stringifyArguments : false,
  showLogLevel : true,
  showMethodName : true,
  separator: '|',
  showConsoleColors: true
};

Vue.use(VueLogger, options);
Vue.use(Axios)

const requireComponent = require.context(
  './components',
  false,
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(
    camelCase(
      fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
    )
  )

  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})  

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

